import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from './constants';

export interface Type<T> extends Function {
  new(...args: any[]): T;
}

export class DomainConverter {
  static dataToDomain<T>(domain: Type<T>, dto: any) {
    const instance = Object.create(domain.prototype);
    instance.__carrier_state = dto;
    return instance as T;
  }

  static domainToData<T>(domain: any) {
    const rqData: any = { query: `${jsonToGraphQLQuery(domain as T)}` };
    return JSON.stringify(rqData);
  }

  static dataToMutation<T>(domain: any, input: any) {
    const rqData: any = {
      query: `mutation ${jsonToGraphQLQuery(domain as T)}`,
      variables: { input }
    };
    return JSON.stringify(rqData);
  }
}


export const roleBasedUrl = (role: string, mode: string) => {
  if (mode && mode || role.includes("quote")) return CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.QUOTE_LOGO_URL;
  if (role.includes("carrier")) return "redirectUrl";
  if (mode != "all" && mode != "truckload" && mode != "intermodal") return CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.WIZARD_GLOBAL_REDIRECT_URL;
  return "common";
}

export const isFPW = (role: string) => role.includes("carrier")
